module.exports = __webpack_public_path__ + "img/table.9c709a3d.svg";